import { JITMeetConferenceGateway } from '../domain/gateways/jit-meet/jit-meet-conference.gateway';
import { JitsiMeetConferenceGateway } from './integrations/jitsi/jitsi-meet-conference.gateway';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ChangePasswordUserUseCaseProvider,
  DeleteProfilePhotoUseCaseProvider,
  GetProfilePhotoUseCaseProvider,
  GetStateTourUseCaseProvider,
  GetUserProfileUseCaseProvider,
  LoginUserUseCaseProvider,
  SendOtpChangePasswordUseProvider,
  SetProfilePhotoUseCaseProvider,
  UpdatePersonalInfoProfileUseCaseProvider,
  ValidateOtpChangePasswordUseCaseProvider,
  ValidateRecaptchaUseCaseProvider,
} from './repositories/user/user-provider';
import { UserRepository } from '../domain/repositories/user.repository';
import { UserImplementationRepository } from './repositories/user/user-implementation.repository';
import {
  DeleteConsentUseCaseProvider,
  DeleteTypeCanalUseCaseProvider,
  DeleteThirdCompanyUseCaseProvider,
  GetAgreementUseCaseProvider,
  GetCampusCompanyUseCaseProvider,
  GetCanalUseCaseProvider,
  GetCityUseCaseProvider,
  GetCollaboratorCompanyUseCaseProvider,
  GetConsentUseCaseProvider,
  GetConsultancyCompanyUseCaseProvider,
  GetCountryUseCaseProvider,
  GetMetodoPagoSaludUseCaseProvider,
  GetDepartamentUseCaseProvider,
  GetDiagnosticUseCaseProvider,
  GetEPSUseCaseProvider,
  GetGenderUseCaseProvider,
  GetInvoiceUseCaseProvider,
  GetLocationUseCaseProvider,
  GetPendingInvoiceReportUseCaseProvider,
  GetPrepaidMedicineUseCaseProvider,
  GetProfessionalUseCaseProvider,
  GetRelationShipUseCaseProvider,
  GetRevisionUseCaseProvider,
  GetServiceCompanyUseCaseProvider,
  GetStateCivilUseCaseProvider,
  GetStateProspectFollowupUseCaseProvider,
  GetStateProspectUseCaseProvider,
  GetTypeBloodUseCaseProvider,
  GetTypeCanalUseCaseProvider,
  GetConveniosUseCaseProvider,
  GetTypeDocumentUseCaseProvider,
  GetTypeInvoiceUseCaseProvider,
  GetTypeOrganizationUseCaseProvider,
  GetTypeServiceCompanyUseCaseProvider,
  InsertConsentUseCaseProvider,
  InsertInvoiceUseCaseProvider,
  InsertTypeCanalUseCaseProvider,
  UpdateConsentUseCaseProvider,
  UpdateTypeCanalUseCaseProvider,
  UpdateThirdCompanyUseCaseProvider,
  GetMetodoPagoFinancieroUseCaseProvider,
  GetTipoPlanSaludUseCaseProvider,
  InsertConvenioUseCaseProvider,
  InsertThirdCompanyUseCaseProvider,
  GetThirdCompanyAllUseCaseProvider,
  GetThirdCompanyUseCaseProvider,
  GetThirdCompanyByIdUseCaseProvider,
  UpdateConvenioUseCaseProvider,
  DeleteConvenioUseCaseProvider,
  GetFiscalResponsibilityUseCaseProvider,
  GetInvoiceRIPSConfigurationByCompanyUseCaseCaseProvider,
  GetInvoiceRIPSByCompanyIdAdminUseCaseProvider,
  InsertInvoiceRIPSByCompanyIdAdminUseCaseProvider,
  UpdateInvoiceRIPSConfigurationUseCaseProvider,
  UpdateInvoiceRIPSByCompanyIdAdminUseCaseProvider,
  InsertInvoiceRIPSConfigurationUseCaseProvider,
  GetOrganizationTypeInvoiceRIPSUseCaseProvider,
  GetEnablingsCodeUseCaseProvider,
  GetBusinessAllUseCaseProvider,
  GetBusinessByIdUseCaseProvider,
  InsertBusinessUseCaseProvider,
  GetTypeBusinessUseCaseProvider,
  UpdateBusinessUseCaseProvider,
  UpdateLogoBusinessUseCaseProvider,
  GetUsersUseCaseProvider,
  GetHeadquarterssUseCaseProvider,
  GetHeadquartersAllByCompanyIdAdminUseCaseProvider,
  InsertHeadquarterssUseCaseProvider,
  InsertHeadquartersAdminUseCaseProvider,
  UpdateHeadquartersUseCaseProvider,
  UpdateHeadquartersAdminUseCaseProvider,
  DeleteHeadquartersUseCaseProvider,
  GetChargeUseCaseProvider,
  GetTypeServiceUseCaseProvider,
  GetServiceUseCaseProvider,
  InsertDemoBusinessUseCaseProvider,
  InsertOfficessUseCaseProvider,
  InsertOfficesIdAdminUseCaseProvider,
  UpdateOfficesUseCaseProvider,
  UpdateOfficesIdAdminUseCaseProvider,
  DeleteOfficesUseCaseProvider,
  DeleteOfficesIdAdminUseCaseProvider,
  GetOfficessUseCaseProvider,
  GetOfficeByHeadquartersIdAdminUseCaseProvider,
  GetCollaboratorCompanyAllUseCaseProvider,
  GetCollaboratorAllAdminUseCaseProvider,
  GetStateCollaboratorUseCaseProvider,
  InsertCollaboratorUseCaseProvider,
  InsertCollaboratorAllAdminUseCaseProvider,
  UpdateCollaboratorUseCaseProvider,
  UpdateCollaboratorAllAdminUseCaseProvider,
  GetCollaboratorPositionUseCaseProvider,
  InsertCollaboratorPositionUseCaseProvider,
  UpdateCollaboratorPositionUseCaseProvider,
  GetPlanBusinessUseCaseProvider,
  GetPlanBussinesIdAdminUseCaseProvider,
  InsertScheduleProfessionalUseCaseProvider,
  UpdateScheduleProfessionalUseCaseProvider,
  GetScheduleProfessionalByIdConpanyUseCaseProvider,
} from './repositories/configuration/configuration-provider';
import { ConfigurationRepository } from '../domain/repositories/configuration.repository';
import { ConfigurationImplementationRepository } from './repositories/configuration/configuration-implementation.repository';
import {
  DeleteComercialUseCaseProvider,
  GetComercialAllUseCaseProvider,
  GetComercialPagedUseCaseProvider,
  GetComercialByIdUseCaseProvider,
  GetFollowupByIdUseCaseProvider,
  GetFollowupReasonsUseCaseProvider,
  DownloadCommercialDocumentUseCaseProvider,
  DownloadSignedConsentDocumentUseCaseProvider,
  GetTypeLicenseUseCaseProvider,
  InsertComercialUseCaseProvider,
  InsertFollowupUseCaseProvider,
  UpdateComercialUseCaseProvider,
  GetValidateFollowupUseCaseProvider,
  GetProductUseCaseProvider,
  SaveQuotationTaxUseCaseProvider,
  GetQuotationTaxesUseCaseProvider,
  GetContractualValiditiesUseCaseProvider,
  GetTeleconsultaInterestUseCaseProvider,
  InsertTeleconsultaInterestUseCaseProvider,
  GetCommercialConsentUseCaseProvider,
  RespondCommercialConsentUseCaseProvider,
  ComercialV1QueryUseCaseProvider,
} from './repositories/comercial/comercial-provider';
import { ComercialRepository } from '../domain/repositories/comercial.repository';
import { ComercialImplementationRepository } from './repositories/comercial/comercial-implementation.repository';
import { ClientRepository } from '../domain/repositories/client.repository';
import {
  GetClientAllUseCaseProvider,
  GetClientByIdUseCaseProvider,
  GetClientKeywordAllStatesUseCaseProvider,
  InsertClientUseCaseProvider,
  StatusClientUseCaseProvider,
  UpdateClientUseCaseProvider,
} from './repositories/client/client-provider';
import { ClientImplementationRepository } from './repositories/client/client-implementation.repository';
import {
  GetAttentionConsecutiveUseCaseProvider,
  GetAttentionReportByDateUseCaseProvider,
  GetDetalleAtencionReportUseCaseProvider,
  GetStepServiceUseCaseProvider,
  GetTypeConsultUseCaseProvider,
  GetTypeDocumentsUseCaseProvider,
  InsertAttentionUseCaseProvider,
  InsertFacturaTerceroUseCaseProvider,
  GetFacturaTerceroUseCaseProvider,
  InsertBackgroundUseCaseProvider,
  InsertConfirmationUseCaseProvider,
  InsertConsultUseCaseProvider,
  InsertDataInitialUseCaseProvider,
  InsertDevelopmentUseCaseProvider,
  InsertDiagnosticUseCaseProvider,
  InsertDocumentsUseCaseProvider,
  InsertGeneralUseCaseProvider,
  InsertOthersUseCaseProvider,
  InsertRevisionUseCaseProvider,
  InsertVitalSignsUseCaseProvider,
  UpdateAttentionUseCaseProvider,
  UpdateBackgroundUseCaseProvider,
  UpdateConsultUseCaseProvider,
  UpdateDataInitialUseCaseProvider,
  UpdateDevelopmentUseCaseProvider,
  UpdateDiagnosticUseCaseProvider,
  UpdateDocumentsUseCaseProvider,
  UpdateGeneralUseCaseProvider,
  UpdateOthersUseCaseProvider,
  UpdateRevisionUseCaseProvider,
  UpdateVitalSignsUseCaseProvider,
  CancelAttentionUseCaseProvider,
  DeleteDocumentUseCaseProvider,
  GetDocumentsByClientUseCaseProvider,
  GetTypeDiagnosticUseCaseProvider,
  GetTypeModalityUseCaseProvider,
  GetTypeResidentialAreaUseCaseProvider,
  GetTypeIncomeUseCaseProvider,
  GetTypeUserUseCaseProvider,
  GetTypeModalityByIdUseCaseProvider,
  GetTypeClasificationDiagnosticUseCaseProvider,
  GetRipsReportByDateUseCaseProvider,
  GetAttentionInProgressUseCaseProvider,
  GetAttentionAllStatesUseCaseProvider,
  GetElectrocardiogramWavesUseCaseProvider,
  GetElectrocardiogramRythmUseCaseProvider,
  InsertCardiovascularScreeningUseCaseProvider,
  UpdateCardiovascularScreeningUseCaseProvider,
  GetTypeFinalityUseCaseProvider,
  GetTypeCauseUseCaseProvider,
  GetViaEnterUseCaseProvider,
  InsertProcedureUseCaseProvider,
  UpdateProcedureUseCaseProvider,
  GetOriginUseCaseProvider,
  GetExtensionUseCaseProvider,
  InsertInabilityUseCaseProvider,
  UpdateInabilityUseCaseProvider,
  InsertConsultOptometryUseCaseProvider,
  UpdateConsultOptometryUseCaseProvider,
  InsertBackgroundOptometryUseCaseProvider,
  UpdateBackgroundOptometryUseCaseProvider,
  GetTypeGlassesUseCaseProvider,
  GetTypeMaterialGlassesUseCaseProvider,
  InsertLensiometryUseCaseProvider,
  UpdateLensiometryUseCaseProvider,
  GetTypeFilterGlassesUseCaseProvider,
  InsertOftalmoscopyUseCaseProvider,
  UpdateOftalmoscopyUseCaseProvider,
  UpdateVisualAcuityUseCaseProvider,
  InsertVisualAcuityUseCaseProvider,
  GetDominantEyeUseCaseProvider,
  InsertTestExternalUseCaseProvider,
  UpdateTestExternalUseCaseProvider,
  UpdateBiomicroscopyUseCaseProvider,
  InsertBiomicroscopyUseCaseProvider,
  InsertSurfaceFilmUseCaseProvider,
  UpdateSurfaceFilmUseCaseProvider,
  UpdateDeviationUseCaseProvider,
  InsertDeviationUseCaseProvider,
  GetTypeLookUseCaseProvider,
  InsertKerotometryUseCaseProvider,
  UpdateKerotometryUseCaseProvider,
  GetTypeRetinoscopyUseCaseUseCaseProvider,
  InsertRetinoscopyUseCaseProvider,
  UpdateRetinoscopyUseCaseProvider,
  InsertSubjetiveUseCaseProvider,
  UpdateSubjetiveUseCaseProvider,
  InsertTuningUseCaseProvider,
  UpdateTuningUseCaseProvider,
  InsertPrescriptionUseCaseProvider,
  UpdatePrescriptionUseCaseProvider,
  UpdateMotilityUseCaseProvider,
  InsertMotilityUseCaseProvider,
  GetVersionUseCaseProvider,
  GetKappaUseCaseProvider,
  InsertOthersOptometryUseCaseProvider,
  UpdateOthersOptometryUseCaseProvider,
  GetTypeBirthUseCaseProvider,
  InsertBackgroundNeuropsychologyUseCaseProvider,
  UpdateBackgroundNeuropsychologyUseCaseProvider,
  UpdateDevelopmentNeuropsychologyUseCaseProvider,
  InsertDevelopmentNeuropsychologyUseCaseProvider,
  InsertCompositionNeuropsychologyUseCaseProvider,
  UpdateCompositionNeuropsychologyUseCaseProvider,
  DeleteRecordScholUseCaseProvider,
  DeleteFamilyCompositionUseCaseProvider,
  UpdateHistoryScholNeuropsychologyUseCaseProvider,
  InsertHistoryScholNeuropsychologyUseCaseProvider,
  InsertSpasmPhysiotherapyUseCaseProvider,
  InsertRehabilitationPhysiotherapyUseCaseProvider,
  UpdateSpasmPhysiotherapyUseCaseProvider,
  UpdateRehabilitationPhysiotherapyUseCaseProvider,
  GetAffectedAreaPhysiotherapyUseCaseProvider,
  GetMuscleEvaluationPhysiotherapyUseCaseProvider,
  InsertMuscleEvaluationPhysiotherapyUseCaseProvider,
  GetMembersPhysiotherapyUseCaseProvider,
  GetStateArcMotionPhysiotherapyUseCaseProvider,
  InsertArcMotionPhysiotherapyUseCaseProvider,
  DeleteMuscleEvaluationPhysiotherapyUseCaseProvider,
  DeleteArcMotionPhysiotherapyUseCaseProvider,
  GetActivityDailyPhysiotherapyUseCaseProvider,
  InsertPainScalePhysiotherapyUseCaseProvider,
  UpdatePainScalePhysiotherapyUseCaseProvider,
  GetListPainScalePhysiotherapyUseCaseProvider,
  GetTypeHealthHabitPhysiotherapyUseCaseProvider,
  InsertHealthHabitPhysiotherapyUseCaseProvider,
  UpdateHealthHabitPhysiotherapyUseCaseProvider,
  InsertBackgroundPhysiotherapyUseCaseProvider,
  UpdateBackgroundPhysiotherapyUseCaseProvider,
  GetTypeScarPhysiotherapyUseCaseProvider,
  InsertDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider,
  UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider,
  InsertTransferPhysiotherapyUseCaseProvider,
  UpdateTransferPhysiotherapyUseCaseProvider,
  GetTypeTransferPhysiotherapyUseCaseProvider,
  InsertAnalysisMarchPhysiotherapyUseCaseProvider,
  UpdateAnalysisMarchPhysiotherapyUseCaseProvider,
  GetSpasticityNeurologyUseCaseProvider,
  GetHypotoniaNeurologyUseCaseProvider,
  GetStaticDinamicEquilibriumNeurologyUseCaseProvider,
  GetPlanePostureNeurologyUseCaseProvider,
  InsertExplorationNeurologyUseCaseProvider,
  UpdateExplorationNeurologyUseCaseProvider,
  DeleteConsentConsultUseCaseProvider,
  GetTypeAvailableDocumentUseCaseProvider,
  GetLastAttentionUseCaseProvider,
  GetConsentByIdUseCaseProvider,
  InsertVitalSignsMedicalUseCaseProvider,
  UpdateVitalSignsMedicalUseCaseProvider,
  GetTypeStateTestFisicalUseCaseProvider,
  InsertTestFisicalUseCaseProvider,
  UpdateTestFisicalUseCaseProvider,
  GetConsentPendientByIdUseCaseProvider,
  SendConsentUseCaseProvider,
  SignConsentUseCaseProvider,
  UpdateDevelopmentConsultOccupationalTherapyUseCaseProvider,
  InsertDevelopmentConsultOccupationalTherapyUseCaseProvider,
  GetMedicationUseCaseProvider,
  GetUnitsTimeUseCaseProvider,
  GetRoutesAdministrationUseCaseProvider,
  GetCalculatedFormulaUseCaseProvider,
  UpdateProcedureMedicationUseCaseProvider,
  InsertProcedureMedicationUseCaseProvider,
  InsertProcedureAtenttionUseCaseProvider,
  UpdateProcedureAtenttionUseCaseProvider,
  GetAttentionByStepUseCaseProvider,
  GetDataBasicAttentionByIdUseCaseProvider,
  CreatePendingHCDListByIdUseCaseProvider,
  CreateTeleconsultaUseCaseProvider,
  ActivateTeleconsultaUseCaseProvider,
  GetTeleconsultaByIdUseCaseProvider,
  ActivateDocumentReprocessUseCaseProvider,
  GetAttentionReprocessListUseCaseProvider,
  GetAttentionStateUseCaseProvider,
} from './repositories/consult/consult-provider';
import { ConsultRepository } from '../domain/repositories/consult.repository';
import { ConsultImplementationRepository } from './repositories/consult/consult-implementation.repository';
import {
  GetIpLocationUseCaseProvider,
  GetIpUseCaseProvider,
} from './repositories/thirdparty/thirdparty-provider';
import { ThirdPartyRepository } from '../domain/repositories/thirdparty.repository';
import { ThirdPartyImplementationRepository } from './repositories/thirdparty/thirdparty-implementation.repository';
import { GetDoseUseCaseProvider, GetTypeProcedureUseCaseProvider, GetProcedureNonSurgicalUseCaseProvider } from './repositories/consult/consult-provider';


import {
GetDocumentsSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
CreateDocumentSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
UpdateDocumentsSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
GetFileDocumentsSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
CreateFileDocumentsSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
UpdateFileDocumentsSystemUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
GetChannelSendUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
CreateChannelSendUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
UpdateChannelSendUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
GetFileDocumentsSystemByIdUseCaseProvider
} from './repositories/configuration/configuration-provider';


import {
GetDocumentsSystemGeneratesUseCaseProvider
} from './repositories/certificate/certificate-provider';


import {
InsertDocumentSystemGenerateUseCaseProvider
} from './repositories/certificate/certificate-provider';


import {
UpdateDocumentSystemGenerateUseCaseProvider
} from './repositories/certificate/certificate-provider';
import { CertificateRepository } from '../domain/repositories/certificate.repository';
import { CertificateImplementationRepository } from './repositories/certificate/certificate-implementation.repository';


import {
GetAllMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
InsertMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
UpdateMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
GetAllPerfilUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
InsertPerfilUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
UpdatePerfilUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
GetAllPerfilMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';

import {
InsertPerfilMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';
import {
DeletePerfilMenuUseCaseProvider
} from './repositories/configuration/configuration-provider';
import {
GetAllPerfilMenuByIdUseCaseProvider
} from './repositories/configuration/configuration-provider';

import { JITMeetRepository } from '../domain/repositories/jit-meet.repository';
import { JITMeetImplementationRepository } from './repositories/jit-meet/jit-meet-implementation.repository';
import { GetCategoryAcademyAllUseCaseProvider, GetContentAcademyByIdUseCaseProvider } from './repositories/academy/academy-provider';

import {
InsertCategoryAcademyUseCaseProvider
} from './repositories/academy/academy-provider';
import { AcademyRepository } from '../domain/repositories/academy.repository';
import { AcademyImplementationRepository } from './repositories/academy/academy-implementation.repository';

import {
UpdateCategoryAcademyUseCaseProvider
} from './repositories/academy/academy-provider';

import {
GetAllContentAcademyUseCaseProvider
} from './repositories/academy/academy-provider';


import {
InsertContentAcademyUseCaseProvider
} from './repositories/academy/academy-provider';


import {
UpdateContentAcademyUseCaseProvider
} from './repositories/academy/academy-provider';


import {
InsertContentResourceUseCaseProvider
} from './repositories/academy/academy-provider';


import {
UpdateContentResourseUseCaseProvider
} from './repositories/academy/academy-provider';


import {
GetContentResourceByIdUseCaseProvider
} from './repositories/academy/academy-provider';


import {
GetAllTypeResourceUseCaseProvider
} from './repositories/academy/academy-provider';


import {
InsertTypeResourceUseCaseProvider
} from './repositories/academy/academy-provider';


import {
UpdatetyperesourceUseCaseProvider
} from './repositories/academy/academy-provider';


import {
GetalltypemimeUseCaseProvider
} from './repositories/academy/academy-provider';


import {
InsertTypeMimeUseCaseProvider
} from './repositories/academy/academy-provider';


import {
UpdateTypeMimeUseCaseProvider
} from './repositories/academy/academy-provider';


import {
GetBusinessByPagedUseCaseProvider
} from './repositories/configuration/configuration-provider';
import { GetUserProfileUseCase } from '../domain/usecases/user/get-user-profile-usecase';


import {
GetBusinessByIdAdminUseCaseProvider
} from './repositories/configuration/configuration-provider';

@NgModule({
  providers: [
    GetBusinessByIdAdminUseCaseProvider,
    GetBusinessByPagedUseCaseProvider,
    /**Academy */
    UpdateTypeMimeUseCaseProvider,
    InsertTypeMimeUseCaseProvider,
    GetalltypemimeUseCaseProvider,
    UpdatetyperesourceUseCaseProvider,
    InsertTypeResourceUseCaseProvider,
    GetAllTypeResourceUseCaseProvider,
    GetContentResourceByIdUseCaseProvider,
    UpdateContentResourseUseCaseProvider,
    InsertContentResourceUseCaseProvider,
    GetContentAcademyByIdUseCaseProvider,
    UpdateContentAcademyUseCaseProvider,
    InsertContentAcademyUseCaseProvider,
    GetAllContentAcademyUseCaseProvider,
    UpdateCategoryAcademyUseCaseProvider,
    InsertCategoryAcademyUseCaseProvider,
    GetCategoryAcademyAllUseCaseProvider,
    {
      provide:AcademyRepository,
      useClass: AcademyImplementationRepository
    },
    /**Certificados Generados */
    InsertDocumentSystemGenerateUseCaseProvider,
    UpdateDocumentSystemGenerateUseCaseProvider,
    GetDocumentsSystemGeneratesUseCaseProvider,
    { provide: CertificateRepository, useClass: CertificateImplementationRepository },
    /** Configuracion */
    DeletePerfilMenuUseCaseProvider,
    InsertPerfilMenuUseCaseProvider,
    GetAllPerfilMenuUseCaseProvider,
    GetAllPerfilMenuByIdUseCaseProvider,
    UpdatePerfilUseCaseProvider,
    InsertPerfilUseCaseProvider,
    GetAllPerfilUseCaseProvider,
    GetDocumentsSystemUseCaseProvider,
    GetFileDocumentsSystemByIdUseCaseProvider,
    UpdateChannelSendUseCaseProvider,
    CreateChannelSendUseCaseProvider,
    GetChannelSendUseCaseProvider,
    UpdateFileDocumentsSystemUseCaseProvider,
    CreateFileDocumentsSystemUseCaseProvider,
    GetFileDocumentsSystemUseCaseProvider,
    UpdateDocumentsSystemUseCaseProvider,
    CreateDocumentSystemUseCaseProvider,
    GetDocumentsSystemUseCaseProvider,
    UpdateMenuUseCaseProvider,
    InsertMenuUseCaseProvider,
    GetAllMenuUseCaseProvider,
    GetTipoPlanSaludUseCaseProvider,
    GetMetodoPagoFinancieroUseCaseProvider,
    GetMetodoPagoSaludUseCaseProvider,
    GetFiscalResponsibilityUseCaseProvider,
    GetCountryUseCaseProvider,
    GetChargeUseCaseProvider,
    GetTypeServiceUseCaseProvider,
    GetEnablingsCodeUseCaseProvider,
    GetTypeOrganizationUseCaseProvider,
    GetOrganizationTypeInvoiceRIPSUseCaseProvider,
    GetDepartamentUseCaseProvider,
    GetCityUseCaseProvider,
    GetLocationUseCaseProvider,
    GetTypeDocumentUseCaseProvider,
    GetStateCivilUseCaseProvider,
    GetEPSUseCaseProvider,
    GetGenderUseCaseProvider,
    GetRelationShipUseCaseProvider,
    GetAgreementUseCaseProvider,
    GetPrepaidMedicineUseCaseProvider,
    GetDiagnosticUseCaseProvider,
    GetRevisionUseCaseProvider,
        // -- Invoice RIPS Configuration
    GetInvoiceRIPSConfigurationByCompanyUseCaseCaseProvider,
    GetInvoiceRIPSByCompanyIdAdminUseCaseProvider,
    InsertInvoiceRIPSByCompanyIdAdminUseCaseProvider,
    UpdateInvoiceRIPSConfigurationUseCaseProvider,
    UpdateInvoiceRIPSByCompanyIdAdminUseCaseProvider,
    InsertInvoiceRIPSConfigurationUseCaseProvider,
    //--Sedes
    GetHeadquarterssUseCaseProvider,
    GetHeadquartersAllByCompanyIdAdminUseCaseProvider,
    InsertHeadquarterssUseCaseProvider,
    InsertHeadquartersAdminUseCaseProvider,
    UpdateHeadquartersUseCaseProvider,
    UpdateHeadquartersAdminUseCaseProvider,
    DeleteHeadquartersUseCaseProvider,
    //--Consultorio
    GetOfficessUseCaseProvider,
    GetOfficeByHeadquartersIdAdminUseCaseProvider,
    InsertOfficessUseCaseProvider,
    InsertOfficesIdAdminUseCaseProvider,
    UpdateOfficesUseCaseProvider,
    UpdateOfficesIdAdminUseCaseProvider,
    DeleteOfficesUseCaseProvider,
    DeleteOfficesIdAdminUseCaseProvider,
    //--Convenio
    GetConveniosUseCaseProvider,
    UpdateConvenioUseCaseProvider,
    InsertConvenioUseCaseProvider,
    DeleteConvenioUseCaseProvider,
    //--Tipo de canal
    GetTypeCanalUseCaseProvider,
    InsertTypeCanalUseCaseProvider,
    UpdateTypeCanalUseCaseProvider,
    DeleteTypeCanalUseCaseProvider,
    //--Canal
    GetCanalUseCaseProvider,
    //--Users
    GetUsersUseCaseProvider,
    GetStateProspectUseCaseProvider,
    GetStateProspectFollowupUseCaseProvider,
    GetTypeBloodUseCaseProvider,
    //-- Company
    GetCampusCompanyUseCaseProvider,
    GetConsultancyCompanyUseCaseProvider,
    GetTypeServiceCompanyUseCaseProvider,
    GetServiceUseCaseProvider,
    GetServiceCompanyUseCaseProvider,
    GetCollaboratorCompanyUseCaseProvider,
    GetCollaboratorCompanyAllUseCaseProvider,
    GetCollaboratorAllAdminUseCaseProvider,
    GetStateCollaboratorUseCaseProvider,
    InsertCollaboratorUseCaseProvider,
    InsertCollaboratorAllAdminUseCaseProvider,
    UpdateCollaboratorUseCaseProvider,
    UpdateCollaboratorAllAdminUseCaseProvider,
    //-- ThirdCompany
    GetThirdCompanyByIdUseCaseProvider,
    GetThirdCompanyUseCaseProvider,
    GetThirdCompanyAllUseCaseProvider,
    InsertThirdCompanyUseCaseProvider,
    UpdateThirdCompanyUseCaseProvider,
    DeleteThirdCompanyUseCaseProvider,
    //-- Invice
    GetTypeInvoiceUseCaseProvider,
    GetInvoiceUseCaseProvider,
    GetProfessionalUseCaseProvider,
    GetPendingInvoiceReportUseCaseProvider,
    InsertInvoiceUseCaseProvider,
    //--Consentimiento
    GetConsentUseCaseProvider,
    InsertConsentUseCaseProvider,
    UpdateConsentUseCaseProvider,
    DeleteConsentUseCaseProvider,
    /**Business */
    GetBusinessAllUseCaseProvider,
    GetPlanBusinessUseCaseProvider,
    GetPlanBussinesIdAdminUseCaseProvider,
    GetBusinessByIdUseCaseProvider,
    GetTypeBusinessUseCaseProvider,
    InsertBusinessUseCaseProvider,
    UpdateBusinessUseCaseProvider,
    InsertDemoBusinessUseCaseProvider,
    UpdateLogoBusinessUseCaseProvider,
     /**Cargos*/
    GetCollaboratorPositionUseCaseProvider,
    InsertCollaboratorPositionUseCaseProvider,
    UpdateCollaboratorPositionUseCaseProvider,
    GetBusinessAllUseCaseProvider,
    { provide: ConfigurationRepository, useClass: ConfigurationImplementationRepository },
    InsertScheduleProfessionalUseCaseProvider,
    UpdateScheduleProfessionalUseCaseProvider,
    GetScheduleProfessionalByIdConpanyUseCaseProvider,
    /** Usuarios*/
    LoginUserUseCaseProvider,
    SendOtpChangePasswordUseProvider,
    ValidateOtpChangePasswordUseCaseProvider,
    ChangePasswordUserUseCaseProvider,
    ValidateRecaptchaUseCaseProvider,
    GetStateTourUseCaseProvider,
    GetUserProfileUseCaseProvider,
    GetProfilePhotoUseCaseProvider,
    SetProfilePhotoUseCaseProvider,
    DeleteProfilePhotoUseCaseProvider,
    UpdatePersonalInfoProfileUseCaseProvider,
    {provide: UserRepository, useClass: UserImplementationRepository},
    /** Comercial*/
    InsertComercialUseCaseProvider,
    InsertFollowupUseCaseProvider,
    GetComercialAllUseCaseProvider,
    GetComercialPagedUseCaseProvider,
    GetComercialByIdUseCaseProvider,
    ComercialV1QueryUseCaseProvider,
    GetFollowupByIdUseCaseProvider,
    GetFollowupReasonsUseCaseProvider,
    DownloadCommercialDocumentUseCaseProvider,
    DownloadSignedConsentDocumentUseCaseProvider,
    GetValidateFollowupUseCaseProvider,
    GetTypeLicenseUseCaseProvider,
    DeleteComercialUseCaseProvider,
    UpdateComercialUseCaseProvider,
    GetProductUseCaseProvider,
  SaveQuotationTaxUseCaseProvider,
  GetQuotationTaxesUseCaseProvider,
  GetContractualValiditiesUseCaseProvider,
    //TELECONSULTA PROVISIONAL BUSCAR EN COMERCIAL
    GetTeleconsultaInterestUseCaseProvider,
    InsertTeleconsultaInterestUseCaseProvider,
    GetCommercialConsentUseCaseProvider,
    RespondCommercialConsentUseCaseProvider,
    {
      provide: ComercialRepository,
      useClass: ComercialImplementationRepository,
    },
    /** Client */
    GetClientKeywordAllStatesUseCaseProvider,
    GetClientAllUseCaseProvider,
    GetClientByIdUseCaseProvider,
    StatusClientUseCaseProvider,
    UpdateClientUseCaseProvider,
    InsertClientUseCaseProvider,
    { provide: ClientRepository, useClass: ClientImplementationRepository },
    /**Consult */
    GetTypeDocumentsUseCaseProvider,
    GetTypeDiagnosticUseCaseProvider,
    GetTypeIncomeUseCaseProvider,
    GetTypeModalityUseCaseProvider,
    GetTypeModalityByIdUseCaseProvider,
    GetTypeResidentialAreaUseCaseProvider,
    GetRipsReportByDateUseCaseProvider,
    GetDataBasicAttentionByIdUseCaseProvider,
    GetAttentionReportByDateUseCaseProvider,
    GetDetalleAtencionReportUseCaseProvider,
    GetAttentionConsecutiveUseCaseProvider,
    GetAttentionByStepUseCaseProvider,
    GetDocumentsByClientUseCaseProvider,
    GetStepServiceUseCaseProvider,
    GetTypeConsultUseCaseProvider,
    GetTypeCauseUseCaseProvider,
    GetTypeStateTestFisicalUseCaseProvider,
    GetTypeFinalityUseCaseProvider,
    GetTypeUserUseCaseProvider,
    GetTypeClasificationDiagnosticUseCaseProvider,
    GetAttentionInProgressUseCaseProvider,
    GetLastAttentionUseCaseProvider,
    GetAttentionAllStatesUseCaseProvider,
    GetElectrocardiogramWavesUseCaseProvider,
    GetElectrocardiogramRythmUseCaseProvider,
    GetViaEnterUseCaseProvider,
    GetOriginUseCaseProvider,
    GetExtensionUseCaseProvider,
    GetTypeGlassesUseCaseProvider,
    GetTypeMaterialGlassesUseCaseProvider,
    GetTypeFilterGlassesUseCaseProvider,
    GetDominantEyeUseCaseProvider,
    GetTypeLookUseCaseProvider,
    GetTypeRetinoscopyUseCaseUseCaseProvider,
    GetVersionUseCaseProvider,
    GetKappaUseCaseProvider,
    GetTypeBirthUseCaseProvider,
    GetAffectedAreaPhysiotherapyUseCaseProvider,
    GetMembersPhysiotherapyUseCaseProvider,
    GetMuscleEvaluationPhysiotherapyUseCaseProvider,
    GetStateArcMotionPhysiotherapyUseCaseProvider,
    GetActivityDailyPhysiotherapyUseCaseProvider,
    GetListPainScalePhysiotherapyUseCaseProvider,
    GetTypeHealthHabitPhysiotherapyUseCaseProvider,
    GetTypeScarPhysiotherapyUseCaseProvider,
    GetTypeTransferPhysiotherapyUseCaseProvider,
    GetSpasticityNeurologyUseCaseProvider,
    GetHypotoniaNeurologyUseCaseProvider,
    GetStaticDinamicEquilibriumNeurologyUseCaseProvider,
    GetPlanePostureNeurologyUseCaseProvider,
    GetTypeAvailableDocumentUseCaseProvider,
    GetConsentByIdUseCaseProvider,
    GetConsentPendientByIdUseCaseProvider,
    GetFacturaTerceroUseCaseProvider,
    GetMedicationUseCaseProvider,
    GetDoseUseCaseProvider,
    GetTypeProcedureUseCaseProvider,
    GetProcedureNonSurgicalUseCaseProvider,
    GetUnitsTimeUseCaseProvider,
    GetRoutesAdministrationUseCaseProvider,
    GetCalculatedFormulaUseCaseProvider,
    InsertGeneralUseCaseProvider,
    InsertProcedureMedicationUseCaseProvider,
    InsertProcedureAtenttionUseCaseProvider,
    InsertAttentionUseCaseProvider,
    InsertFacturaTerceroUseCaseProvider,
    InsertConsultUseCaseProvider,
    InsertBackgroundUseCaseProvider,
    InsertDiagnosticUseCaseProvider,
    InsertRevisionUseCaseProvider,
    InsertVitalSignsUseCaseProvider,
    InsertVitalSignsMedicalUseCaseProvider,
    InsertOthersUseCaseProvider,
    InsertOthersOptometryUseCaseProvider,
    InsertDocumentsUseCaseProvider,
    InsertConfirmationUseCaseProvider,
    InsertDataInitialUseCaseProvider,
    InsertDevelopmentUseCaseProvider,
    InsertCardiovascularScreeningUseCaseProvider,
    InsertProcedureUseCaseProvider,
    InsertInabilityUseCaseProvider,
    InsertConsultOptometryUseCaseProvider,
    InsertBackgroundOptometryUseCaseProvider,
    InsertLensiometryUseCaseProvider,
    InsertOftalmoscopyUseCaseProvider,
    InsertVisualAcuityUseCaseProvider,
    InsertTestExternalUseCaseProvider,
    InsertTestFisicalUseCaseProvider,
    InsertBiomicroscopyUseCaseProvider,
    InsertSurfaceFilmUseCaseProvider,
    InsertDeviationUseCaseProvider,
    InsertKerotometryUseCaseProvider,
    InsertRetinoscopyUseCaseProvider,
    InsertSubjetiveUseCaseProvider,
    InsertTuningUseCaseProvider,
    InsertPrescriptionUseCaseProvider,
    InsertMotilityUseCaseProvider,
    InsertBackgroundNeuropsychologyUseCaseProvider,
    InsertDevelopmentNeuropsychologyUseCaseProvider,
    InsertCompositionNeuropsychologyUseCaseProvider,
    InsertHistoryScholNeuropsychologyUseCaseProvider,
    InsertSpasmPhysiotherapyUseCaseProvider,
    InsertRehabilitationPhysiotherapyUseCaseProvider,
    InsertMuscleEvaluationPhysiotherapyUseCaseProvider,
    InsertArcMotionPhysiotherapyUseCaseProvider,
    InsertPainScalePhysiotherapyUseCaseProvider,
    InsertHealthHabitPhysiotherapyUseCaseProvider,
    InsertBackgroundPhysiotherapyUseCaseProvider,
    InsertDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider,
    InsertTransferPhysiotherapyUseCaseProvider,
    InsertAnalysisMarchPhysiotherapyUseCaseProvider,
    InsertExplorationNeurologyUseCaseProvider,
    InsertDevelopmentConsultOccupationalTherapyUseCaseProvider,
    UpdateDevelopmentConsultOccupationalTherapyUseCaseProvider,
    UpdateProcedureMedicationUseCaseProvider,
    UpdateProcedureAtenttionUseCaseProvider,
    UpdateAttentionUseCaseProvider,
    UpdateGeneralUseCaseProvider,
    UpdateConsultUseCaseProvider,
    UpdateBackgroundUseCaseProvider,
    UpdateDiagnosticUseCaseProvider,
    UpdateRevisionUseCaseProvider,
    UpdateVitalSignsUseCaseProvider,
    UpdateVitalSignsMedicalUseCaseProvider,
    UpdateOthersUseCaseProvider,
    UpdateDocumentsUseCaseProvider,
    UpdateDataInitialUseCaseProvider,
    UpdateDevelopmentUseCaseProvider,
    UpdateCardiovascularScreeningUseCaseProvider,
    UpdateProcedureUseCaseProvider,
    UpdateInabilityUseCaseProvider,
    UpdateConsultOptometryUseCaseProvider,
    UpdateBackgroundOptometryUseCaseProvider,
    UpdateLensiometryUseCaseProvider,
    UpdateOftalmoscopyUseCaseProvider,
    UpdateVisualAcuityUseCaseProvider,
    UpdateTestExternalUseCaseProvider,
    UpdateTestFisicalUseCaseProvider,
    UpdateBiomicroscopyUseCaseProvider,
    UpdateSurfaceFilmUseCaseProvider,
    UpdateDeviationUseCaseProvider,
    UpdateKerotometryUseCaseProvider,
    UpdateRetinoscopyUseCaseProvider,
    UpdateSubjetiveUseCaseProvider,
    UpdateTuningUseCaseProvider,
    UpdatePrescriptionUseCaseProvider,
    UpdateMotilityUseCaseProvider,
    UpdateOthersOptometryUseCaseProvider,
    UpdateBackgroundNeuropsychologyUseCaseProvider,
    UpdateDevelopmentNeuropsychologyUseCaseProvider,
    UpdateCompositionNeuropsychologyUseCaseProvider,
    UpdateHistoryScholNeuropsychologyUseCaseProvider,
    UpdateSpasmPhysiotherapyUseCaseProvider,
    UpdateRehabilitationPhysiotherapyUseCaseProvider,
    UpdatePainScalePhysiotherapyUseCaseProvider,
    UpdateHealthHabitPhysiotherapyUseCaseProvider,
    UpdateAnalysisMarchPhysiotherapyUseCaseProvider,
    UpdateDiagnosticMedicalRehabilityPhysiotherapyUseCaseProvider,
    UpdateTransferPhysiotherapyUseCaseProvider,
    UpdateExplorationNeurologyUseCaseProvider,
    UpdateBackgroundPhysiotherapyUseCaseProvider,
    CancelAttentionUseCaseProvider,
    // GenerateOtpConsentUseCaseProvider,
    // {provide:ConsultRepository, useClass: ConsultImplementationRepository},
    // ValidateOtpConsentUseCaseProvider,
    // {provide:ConsultRepository, useClass: ConsultImplementationRepository},
    SendConsentUseCaseProvider,
    SignConsentUseCaseProvider,
    DeleteConsentConsultUseCaseProvider,
    DeleteDocumentUseCaseProvider,
    DeleteRecordScholUseCaseProvider,
    DeleteFamilyCompositionUseCaseProvider,
    DeleteMuscleEvaluationPhysiotherapyUseCaseProvider,
    DeleteArcMotionPhysiotherapyUseCaseProvider,
     /**HCD */
    CreatePendingHCDListByIdUseCaseProvider,
    /** Teleconsulta */
    CreateTeleconsultaUseCaseProvider,
    ActivateTeleconsultaUseCaseProvider,
    GetTeleconsultaByIdUseCaseProvider,
    GetAttentionStateUseCaseProvider,
    /**Reproceso de Documentos PDF */
    GetAttentionReprocessListUseCaseProvider,
    ActivateDocumentReprocessUseCaseProvider,
    { provide: ConsultRepository, useClass: ConsultImplementationRepository },
    /**Thirdparty */
    GetIpUseCaseProvider,
    GetIpLocationUseCaseProvider,
    {
      provide: ThirdPartyRepository,
      useClass: ThirdPartyImplementationRepository,
    },

    /** JIT Meet - motor de conferencia */
    {
      provide: JITMeetConferenceGateway,
      useClass: JitsiMeetConferenceGateway,
    },
     {
      provide: JITMeetRepository,
      useClass: JITMeetImplementationRepository,
    },

  ],
  imports: [CommonModule],
})
export class DataModule {}
